"use client";

export interface SchnellfilterOption<T extends string> {
  wert: T;
  label: string;
  /** Zähler hinter dem Namen; nur Sichtbares zählen (r110). Fehlt die Zahl, wird nichts angezeigt. */
  anzahl?: number;
}

const PILLE =
  "py-1 px-2.5 inline-flex items-center gap-x-1.5 text-xs rounded-full border border-layer-line bg-layer text-layer-foreground hover:bg-layer-hover focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-focus disabled:opacity-50 disabled:pointer-events-none";
const PILLE_AKTIV =
  "py-1 px-2.5 inline-flex items-center gap-x-1.5 text-xs font-medium rounded-full border border-primary-200 bg-primary-100 text-primary-800 hover:bg-primary-200 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-focus disabled:opacity-50 disabled:pointer-events-none";

/**
 * Schnellfilter (Musterkatalog M-003 „Kopf“, Design-Guide `schnellfilter.md`): Pillen mit Zähler, genau eine gewählt,
 * `aria-pressed`. Ein zweiter Klick auf die gewählte Pille wählt den Eintrag mit leerem Wert („Alle“) zurück.
 * Kontrolliert; der Aufrufer filtert und zählt.
 */
export function Schnellfilter<T extends string>({
  titel,
  optionen,
  wert,
  leerWert,
  onWahl,
}: {
  titel: string;
  optionen: readonly SchnellfilterOption<T>[];
  wert: T;
  /** Wert für „keine Einschränkung“ (Pille „Alle“). */
  leerWert: T;
  onWahl: (neu: T) => void;
}) {
  return (
    <>
      {/* Preline: forms/forms-sub-filters-refinement/forms-cat-filter-bars/search-and-filter-toolbar */}
      <div className="flex flex-wrap items-center gap-1.5" role="group" aria-label={titel}>
        {optionen.map((o) => {
          const gewaehlt = o.wert === wert;
          return (
            <button
              key={o.wert}
              type="button"
              className={gewaehlt ? PILLE_AKTIV : PILLE}
              aria-pressed={gewaehlt}
              onClick={() => onWahl(gewaehlt && o.wert !== leerWert ? leerWert : o.wert)}
            >
              {o.label}
              {typeof o.anzahl === "number" && <span className="tabular-nums text-muted-foreground-1">{o.anzahl}</span>}
            </button>
          );
        })}
      </div>
    </>
  );
}
